"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const brands = [{
  name: "Audi",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_audi.png"
}, {
  name: "BMW",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_bmw.png"
}, {
  name: "Ford",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_ford.png"
}, {
  name: "Volkswagen",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_vw.png"
}, {
  name: "Mercedes-Benz",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_mercedes.png"
}, {
  name: "Toyota",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_toyota.png"
}, {
  name: "Honda",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_honda.png"
}, {
  name: "Nissan",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_nissan.png"
}, {
  name: "Land Rover",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_land_rover.png"
}, {
  name: "Jaguar",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_jaguar.png"
}, {
  name: "Vauxhall",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_vauxhall.png"
}, {
  name: "Peugeot",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_peugeot.png"
}, {
  name: "Renault",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_renault.png"
}, {
  name: "Citroen",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/logo_citroen.png"
}];
export default function VehiclesWeSupport() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section id="vehicles-we-support" className="relative w-full overflow-hidden bg-[#0f1115] py-16 sm:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-10">
        <div className="h-full w-full" style={{
        backgroundImage: "linear-gradient(to right, #ffffff 1px, transparent 1px)",
        backgroundSize: "4rem 100%"
      }} />
      </div>

      {}
      <div className="relative z-10 mx-auto max-w-7xl px-4">
        {}
        <div ref={headerRef} className={cn("mb-12 text-center transition-all duration-700 ease-out", isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0")}>
          <h2 className="text-sm font-medium uppercase tracking-[0.2em] text-white/60">
            Technology for Every Make
          </h2>
        </div>

        {}
        <div className="relative flex w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]">
          <div className="animate-marquee flex min-w-full shrink-0 items-center justify-around gap-12 px-6 sm:gap-24">
            {brands.map((brand, i) => <div key={`brand-1-${i}`} data-index={i} className="group relative flex items-center justify-center">
                <img src={brand.logo} alt={`${brand.name} logo`} className="h-10 w-auto object-contain opacity-50 transition-all duration-500 filter [filter:grayscale(100%)_brightness(0)_invert(1)] hover:scale-110 hover:opacity-100 hover:[filter:grayscale(0%)_brightness(100%)_invert(0)] sm:h-12" />
              </div>)}
          </div>
          <div aria-hidden="true" className="animate-marquee flex min-w-full shrink-0 items-center justify-around gap-12 px-6 sm:gap-24">
            {brands.map((brand, i) => <div key={`brand-2-${i}`} data-index={i} className="group relative flex items-center justify-center">
                <img src={brand.logo} alt={`${brand.name} logo`} className="h-10 w-auto object-contain opacity-50 transition-all duration-500 filter [filter:grayscale(100%)_brightness(0)_invert(1)] hover:scale-110 hover:opacity-100 hover:[filter:grayscale(0%)_brightness(100%)_invert(0)] sm:h-12" />
              </div>)}
          </div>
        </div>
      </div>

      {}
      <style jsx>{`
        @keyframes marquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-100%);
          }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}